import {connect} from 'react-redux';
import {List} from 'immutable';
import moment from 'moment';

import {
  loadJournalReply,
  updateJournalReply,
  createJournalReply,
  deleteJournalReply,
  journalReplyFormDestroy
} from '../../../../../state/modules/journalReplies/actions';
import {sendMessage} from '../../../../../state/actions';
import JournalReplyForm from '../components/JournalReplyForm';
import Config from '../../../../../Config';

const inputs = List([
  'profile',
  'journal_post_id',
  'journal_post',
  'body',
  'published_at',
  'edited_at',
  'public_status',
  'status'
]);

const mapStateToProps = (state, ownProps) => {

  const data = {}, errors = {};
  for (const val of inputs.values()) {
    data[val] = state.entities.getIn(['journalReplies', ownProps.id, val], '');
    if (['profile'].includes(val)) {
      errors[val] = state.journalReplies.getIn(['form', 'errors', 'user_profile_id']);
    }
    else {
      errors[val] = state.journalReplies.getIn(['form', 'errors', val]);
    }
  }

  // change select number values to strings to work with ant design select inputs
  Object.keys(data).forEach(x => {
    if (['status'].includes(x)) {
      data[x] = data[x].toString();
    }
  });

  data['published_at'] = data['published_at']
    ? moment(data['published_at'], Config.get('API_DATETIME_FORMAT'))
    : moment();

  data['edited_at'] = data['edited_at']
    ? moment(data['edited_at'], Config.get('API_DATETIME_FORMAT'))
    : null;

  return {
    isLoading: state.journalReplies.get('isLoading'),
    isSubmitting: state.journalReplies.getIn(['form', 'isSubmitting']),
    success: state.journalReplies.getIn(['form', 'success']),
    created_id: state.journalReplies.getIn(['form', 'created_id']),
    data: data,
    errors: errors,
    createdAt: state.entities.getIn(['journalReplies', ownProps.id, 'created_at'], null),
    updatedAt: state.entities.getIn(['journalReplies', ownProps.id, 'updated_at'], null),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    load: (id, cb) => {
      dispatch(loadJournalReply(id, cb));
    },
    update: (id, data, cb) => {
      dispatch(updateJournalReply(id, data, cb));
    },
    create: (data, cb) => {
      dispatch(createJournalReply(data, cb));
    },
    delete: (id, cb) => {
      dispatch(deleteJournalReply(id, cb))
    },
    destroyForm: (formState) => {
      dispatch(journalReplyFormDestroy(formState));
    },
    sendMessage: (level, title, body, expires) => {
      dispatch(sendMessage(level, title, body, expires));
    },
  }
}

const JournalReplyFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(JournalReplyForm);

export default JournalReplyFormContainer;
